/**
 * Custom hook to sync authenticated user data to representative fields
 * Handles the "Will you be acting as an Authorized Representative?" checkbox logic
 */

import { useEffect } from "react";

interface UseAuthRepresentativeSyncProps {
  checked: boolean;
  userFirstName: string | null;
  userLastName: string | null;
  userEmail: string | null;
  adminRole: string;
  updateFields: (updates: {
    repFirstName?: string;
    repLastName?: string;
    repEmail?: string;
    representative_title?: string;
  }) => void;
  clearRepresentativeErrors: () => void;
}

/**
 * Hook to automatically sync authenticated user data to representative fields
 * When "checked" is true, representative fields are populated from user auth data
 */
export const useAuthRepresentativeSync = ({
  checked,
  userFirstName,
  userLastName,
  userEmail,
  adminRole,
  updateFields,
  clearRepresentativeErrors,
}: UseAuthRepresentativeSyncProps) => {
  useEffect(() => {
    if (checked) {
      updateFields({
        repFirstName: userFirstName as string,
        repLastName: userLastName as string,
        repEmail: userEmail as string,
        representative_title: adminRole,
      });
      clearRepresentativeErrors();
    }
  }, [
    checked,
    userFirstName,
    userLastName,
    userEmail,
    adminRole,
    updateFields,
    clearRepresentativeErrors,
  ]);
};
